import type { RootState } from '../../../store';

export const stateToDietProps = (state: RootState): Pick<IJWTBody, 'visitreason'> => {
  return {
    visitreason: state.session.data?.visitreason ?? '',
  };
};
